import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { ReactNode, useState } from 'react';

export default function AccordionProgressWrapper({
  triggerChildren,
  children,
}: {
  triggerChildren: ReactNode;
  children: ReactNode;
}) {
  const [isExpanded, setExpanded] = useState(false);
  return (
    <Accordion
      TransitionProps={{
        unmountOnExit: true,
      }}
      sx={{
        marginBottom: '20px',
      }}
      onChange={(e, expanded) => {
        setExpanded(expanded);
      }}
    >
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          boxShadow: !isExpanded ? '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' : 'none',
          borderRadius: '8px',
          transition: 'box-shadow 0.5s ease-in-out',
        }}
      >
        {triggerChildren}{' '}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
